/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StationType {
    Airport = 'Airport',
    Bus = 'Bus',
    Train = 'Train'
}

export function StationTypeFromJSON(json: any): StationType {
    return StationTypeFromJSONTyped(json, false);
}

export function StationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationType {
    return json as StationType;
}

export function StationTypeToJSON(value?: StationType | null): any {
    return value as any;
}

